import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { DirectivesModule } from '../../directives/directives.module';
import { SplitPaneComponent } from './split-pane.component';

@NgModule({
  declarations: [SplitPaneComponent],
  imports: [CommonModule, IonicModule, DirectivesModule],
  exports: [SplitPaneComponent],
})
export class SplitPaneModule {}
